module.exports = __webpack_public_path__ + "static/merkur-47aa8da9c41fb4b26aa0bd23ff8e3159.png";